var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconVectorMap = function SvgIconVectorMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m18.654 5.25-5.218.87-4.468-.745-5.218.87v11.574l5.218-.87 4.345.724.246-1.48-3.841-.64V9.114h-1.5v6.44l-2.968.494V7.515l3.718-.62 3.718.62v6.067h1.5V7.515l2.968-.494v4.327h1.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m23.189 14.283-2.67-3.204-5.17 4.412-.625 1.427-.168 1.843 1.844.168 1.516-.357zm-1.958-.178-.89-1.068-3.916 3.263-.415.949-.03.326.327.03 1.008-.238z",
    clipRule: "evenodd"
  })));
};
export default SvgIconVectorMap;